var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasFeature("FEATURE_ORDERBOXES") && _vm.order.box
    ? _c(
        "div",
        {
          staticClass: "pick-up__single",
          class: { "pick-up__single--full": _vm.order.status != "empty" },
        },
        [
          _vm.order.status != "empty"
            ? [
                _c("div", { staticClass: "pick-up__box" }, [
                  _vm._v("box " + _vm._s(_vm.order.box)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pick-up__number" }, [
                  _vm._v(_vm._s(_vm._f("fwgshortorder")(_vm.order.number))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pick-up__text" }, [
                  _vm._v(_vm._s(_vm.order.order_label)),
                ]),
              ]
            : _c("div", { staticClass: "pick-up__box pick-up__box--empty" }, [
                _vm._v("BOX " + _vm._s(_vm.order.box)),
              ]),
        ],
        2
      )
    : _c("div", { staticClass: "grid__single" }, [
        _c("div", { staticClass: "grid__number" }, [
          _vm._v(_vm._s(_vm._f("fwgshortorder")(_vm.order.number))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__text" }, [
          _vm._v(_vm._s(_vm.order.order_label)),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }